module.exports = __webpack_public_path__ + "static/media/自动写诗).b5c485d1.png";